var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFail1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "153.225 214.286 50.116 50.116",
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: -265.807,
    y: 144.355,
    style: {
      fill: "none"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153.35 255.133 L 169.013 239.473 L 153.35 223.812 L 162.642 214.52 L 178.303 230.183 L 193.963 214.52 L 203.255 223.812 L 187.595 239.473 L 203.255 255.133 L 193.963 264.425 L 178.303 248.765 L 162.642 264.425 L 153.35 255.133 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail1);
export default __webpack_public_path__ + "static/media/fail-1.d963630a33c29437f05ee967846cbab3.svg";
export { ForwardRef as ReactComponent };